export const FETCH_SKILLS_REQUEST = 'FETCH_SKILLS_REQUEST';
export const FETCH_SKILLS_SUCCESS = 'FETCH_SKILLS_SUCCESS';
export const FETCH_SKILLS_FAILURE = 'FETCH_SKILLS_FAILURE';

export const FETCH_SKILLS_NEXT_REQUEST = 'FETCH_SKILLS_NEXT_REQUEST';
export const FETCH_SKILLS_NEXT_SUCCESS = 'FETCH_SKILLS_NEXT_SUCCESS';
export const FETCH_SKILLS_NEXT_FAILURE = 'FETCH_SKILLS_NEXT_FAILURE';

export const UPDATE_SKILL_REQUEST = 'UPDATE_SKILL_REQUEST';
export const UPDATE_SKILL_SUCCESS = 'UPDATE_SKILL_SUCCESS';
export const UPDATE_SKILL_FAILURE = 'UPDATE_SKILL_FAILURE';

export const FETCH_MASTER_DATA_REQUEST = 'FETCH_MASTER_DATA_REQUEST';
export const FETCH_MASTER_DATA_SUCCESS = 'FETCH_MASTER_DATA_SUCCESS';
export const FETCH_MASTER_DATA_FAILURE = 'FETCH_MASTER_DATA_FAILURE';

export const UPDATE_MASTER_DATA_REQUEST = 'UPDATE_MASTER_DATA_REQUEST';
export const UPDATE_MASTER_DATA_SUCCESS = 'UPDATE_MASTER_DATA_SUCCESS';
export const UPDATE_MASTER_DATA_FAILURE = 'UPDATE_MASTER_DATA_FAILURE';

export const ADD_MASTER_DATA_REQUEST = 'ADD_MASTER_DATA_REQUEST';
export const ADD_MASTER_DATA_SUCCESS = 'ADD_MASTER_DATA_SUCCESS';
export const ADD_MASTER_DATA_FAILURE = 'ADD_MASTER_DATA_FAILURE';

export const DELETE_MASTER_DATA_REQUEST = 'DELETE_MASTER_DATA_REQUEST';
export const DELETE_MASTER_DATA_SUCCESS = 'DELETE_MASTER_DATA_SUCCESS';
export const DELETE_MASTER_DATA_FAILURE = 'DELETE_MASTER_DATA_FAILURE';

export const FETCH_WIZARD_DATA_REQUEST = 'FETCH_WIZARD_DATA_REQUEST';
export const FETCH_WIZARD_DATA_SUCCESS = 'FETCH_WIZARD_DATA_SUCCESS';
export const FETCH_WIZARD_DATA_FAILURE = 'FETCH_WIZARD_DATA_FAILURE';

export const FETCH_SKILL_REQUEST = 'FETCH_SKILL_REQUEST';
export const FETCH_SKILL_SUCCESS = 'FETCH_SKILL_SUCCESS';
export const FETCH_SKILL_FAILURE = 'FETCH_SKILL_FAILURE';

export const FETCH_SKILL_PLANTS_REQUEST = 'FETCH_SKILL_PLANTS_REQUEST';
export const FETCH_SKILL_PLANTS_SUCCESS = 'FETCH_SKILL_PLANTS_SUCCESS';
export const FETCH_SKILL_PLANTS_FAILURE = 'FETCH_SKILL_PLANTS_FAILURE';

export const RESET_SKILL = 'RESET_SKILL';
